import axios from '../utils/axios';

export default function getAllTagsList(adminId, params) {
    return axios.get(`/admin/${adminId}/get-all-tags`, { params });
};